/* eslint-disable no-duplicate-case */
import React, { useState, useEffect } from "react";
import { Link, TextContainer, Banner, Modal, TextField, Button, Select, ButtonGroup } from "@shopify/polaris";

import config from "../../config/config";
import callApi from "../../utils/apiCaller";

import Swal from "sweetalert2";
import { Row, Progress, Col } from "reactstrap";
import { FlagMajor, UploadMajor, ExchangeMajor, ReplayMinor } from "@shopify/polaris-icons";
import { useSelector } from "react-redux";
import UserTour from "../UserTour";
import ReviewBanner from "../ReviewBanner";
import BannerWoo from "./BannerWoo";

const BannerHeader = () => {
  const dataStatistical = useSelector((state) => state.dataStatistical);
  const dataSettings = useSelector((state) => state.dataSettings);
  const listStore = useSelector((state) => state.listStore);
  const [openModalSubmitDemo, setOpenModalSubmitDemo] = useState(false);
  const [showLoadingPage, setShowLoadingPage] = useState(false);
  const [optionStore, setOptionStore] = useState([]);
  const [storeSelected, setStoreSelected] = useState(config.shop);
  const [modalActive, setModalActive] = useState(false);
  const [notifyGetAllOrders, setNotifyGetAllOrders] = useState(false);
  const [loadingValue, setLoadingValue] = useState(0);
  const [oldOrderRange, setOldOrderRange] = useState("30");
  const [oldOrderRangeErr, setOldOrderRangeErr] = useState("");
  const [messageLoading] = useState("Please wait a few minutes for the system to get ORDERS from your shop ...");

  useEffect(() => {
    let newOptionStore = [];
    for (let i = 0; i < listStore.length; i++) {
      let dataPush = { label: listStore[i].shop, value: listStore[i].shop };
      newOptionStore.push(dataPush);
    }
    setOptionStore(newOptionStore);
  }, [listStore]);

  const openModalGetOldStatus = () => {
    if (config.role !== "view") {
      setModalActive(true);
    }
  };

  const oldOrderStateFree = async () => {
    await Swal.fire({
      icon: "warning",
      title: "Notice!",
      text: "Please upgrade to Basic plan to use this feature!",
      confirmButtonColor: "#6371c7",
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: "Plan Table",
    });
  };

  const getNotifyGetAllOrders = () => {
    setNotifyGetAllOrders(true);
  };

  const closeModal = async () => {
    setModalActive(false);
  };

  const handleChangeOldOrderRange = async (value) => {
    setOldOrderRangeErr("");
    if (value === "") {
      setOldOrderRangeErr("Date range is required");
    } else {
      const phoneRegEx = new RegExp("^[1-9]");
      if (!phoneRegEx.test(value)) {
        value = "0";
      }

      if (dataSettings.read_all_orders === "0" && value > 60) {
        value = "60";
      }
      if (dataSettings.read_all_orders === "1" && value > 365) {
        value = "365";
      }
    }

    setOldOrderRange(value);
  };

  const processGetOldOrders = async () => {
    if (config.platform === "WOO_COMMERCE") {
      for (let i = 0; i < 100; i++) {
        if (i === 99) {
          let result = await processGetOldOrdersPage(i + 1, "last");
          console.log(result);
          if (result == 0) {
            window.location.reload();
          }
        } else {
          setLoadingValue(i);
          let result = await processGetOldOrdersPage(i + 1, "process");
          console.log(result);
          if (result == 0) {
            window.location.reload();
          }
        }
      }
    } else {
      setShowLoadingPage(true);
      let params = {
        action: "processGetOldOrders",
        oldOrderRange: oldOrderRange,
        store: storeSelected,
      };
      callApi("get", params).then(async (res) => {
        setModalActive(false);
        var count = res.data.count;
        if (res.data.state === 1) {
          if (count > 0) {
            setShowLoadingPage(false);
            Swal.fire({
              icon: "success",
              title: count + " Orders has been found!",
              text: "The system is running to process these orders. It may take few minutes to get update on your dashboard.",
              showCloseButton: false,
              showConfirmButton: true,
            });
          } else {
            Swal.fire({
              icon: "warning",
              title: "Notice!",
              html: "No order has been found. But don't worry, upcoming order will auto receive and submit tracking to Paypal/Stripe.",
              showCloseButton: true,
              showConfirmButton: false,
            });
            setShowLoadingPage(false);
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "Notice!",
            text: res.data.msg,
            showCloseButton: true,
            showConfirmButton: false,
          });
          setShowLoadingPage(false);
        }
      });
    }
  };

  const processGetOldOrdersPage = async (page, status) => {
    setShowLoadingPage(true);
    let params = {
      action: "processGetOldOrdersPage",
      oldOrderRange: oldOrderRange,
      store: storeSelected,
      page: page,
    };
    await callApi("get", params).then(async (res) => {
      if (res.data.countOrders == 0) {
      }
      if (status === "last") {
        setShowLoadingPage(false);
        setModalActive(false);
        if (res.data.state === 1) {
          Swal.fire({
            icon: "success",
            title: "Successfully",
            text: res.data.msg,
            showCloseButton: false,
            showConfirmButton: false,
            timer: 3000,
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: res.data.msg,
            showCancelButton: true,
            showConfirmButton: true,
          });
        }
      }
    });
  };

  const getLinkAcceptScope = () => {
    let redirectUri = "https://apps.omegatheme.com/add-paypal-tracking/get_code.php?status=update_scope";
    let confirmationUrl =
      "https://" +
      config.shop +
      "/admin/oauth/authorize?client_id=59855db23a211ce9ce602feeb5b798c3&redirect_uri=" +
      redirectUri +
      "&scope=read_orders,read_all_orders";
    window.top.location.replace(confirmationUrl);
  };
  return (
    <Row>
      <div className="w-100 ml-3 mr-3">
        <BannerWoo />
        {/* <Banner title="Out of Office Notice" status="info">
          <div className="mt-3">
            Our company will enjoy a five-day holiday from <b>Wednesday, April 30,
            to Sunday, May 4,</b> for the <b>Reunification Day</b> and <b>International
            Workers' Day</b> celebrations. During this time, response times may be
            slower than usual, and full support services will resume <b>on Monday,
            May 5</b>. While our team is away, customer support agents will be
            available to provide limited, basic assistance for urgent matters.
            We appreciate your patience and understanding, and assure you that
            all other inquiries will be addressed promptly when we return. 
            <br/>
            <b>Thank you for your understanding and support!</b>
          </div>
        </Banner> */}
        <Banner status="success" icon={FlagMajor}>
          <Row>
            <Col md={8}>
              {config.platform === "WOO_COMMERCE" ? null : (
                <span>
                  Orders will <strong>automatically</strong> be synced to PayPal as soon as you mark the order as{" "}
                  <strong>fullfilled</strong> and add the tracking number.
                  <br />
                </span>
              )}
              <strong>Do you want to add tracking code to Paypal/Stripe for previous orders?</strong>
            </Col>
            <Col md={4}>
              <div className="float-right">
                <ButtonGroup>
                  {dataSettings.submit_demo === 1 ? (
                    <Button icon={ExchangeMajor} onClick={() => setOpenModalSubmitDemo(true)}>
                      Test Somes Orders
                    </Button>
                  ) : null}

                  <Button icon={ReplayMinor} primary onClick={openModalGetOldStatus}>
                    Process Old Orders
                  </Button>
                </ButtonGroup>
              </div>
            </Col>
          </Row>
        </Banner>
      </div>
      <UserTour type="step" changeStatusModal={() => setOpenModalSubmitDemo(false)} openModal={openModalSubmitDemo} />
      <Modal
        open={modalActive}
        onClose={closeModal}
        title="Would you like to process the old orders?"
        primaryAction={{
          disabled: oldOrderRangeErr === "" ? false : true,
          content: "OK",
          onAction: processGetOldOrders,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: closeModal,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <div style={{ lineHeight: "36px" }}>
              The range for getting old orders (max 365 days)
              <div className="ml-2 mr-2">
                <TextField
                  type="number"
                  value={oldOrderRange}
                  onChange={handleChangeOldOrderRange}
                  error={oldOrderRangeErr}
                  min={0}
                  max={dataSettings.read_all_orders === "0" || config.platform === "WOO_COMMERCE" ? 60 : 365}
                />
              </div>
            </div>
            {optionStore.length > 1 ? (
              <Select
                label="Get old orders for store:"
                options={optionStore}
                onChange={(value) => setStoreSelected(value)}
                value={storeSelected}
              />
            ) : null}
          </TextContainer>
          {dataSettings.read_all_orders === "0" ? (
            <div className="mt-5">
              <Banner status="info">
                <p>
                  To add tracking for <b>orders older than 60 day</b>, please click{" "}
                  <Link onClick={getNotifyGetAllOrders}>here</Link>
                </p>
                <br />
                {notifyGetAllOrders ? (
                  <p>
                    We need <b>read_all_orders</b> permission to get more information about orders older than 60 days.
                    Click <Link onClick={getLinkAcceptScope}> here</Link> to continue
                  </p>
                ) : null}
              </Banner>
            </div>
          ) : null}
        </Modal.Section>
      </Modal>
      {showLoadingPage ? (
        <div id="i_loading_page">
          <div className="loading_page_content" style={{ textAlign: "center" }}>
            <img src="https://linh.omegatheme.com/dev-better-search/admin/images/loading_cart.gif" alt="loading" />
            <p className="mb-4">{messageLoading}</p>

            <Progress
              animated
              style={{
                height: "20px",
                margin: "auto",
                width: "75%",
              }}
              color="info"
              value={loadingValue}
              max="100"
            >
              {" "}
              {loadingValue}%{" "}
            </Progress>
          </div>
        </div>
      ) : null}
    </Row>
  );
};

export default BannerHeader;
